import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_GET_FOLDERS_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_GET_FOLDERS_REQUEST`;
export const PHOTO_CAPTURE_GET_FOLDERS_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_GET_FOLDERS_SUCCESS`;
export const photoCaptureGetFoldersRequestAction = (coCode, contextId) => ({
    type: PHOTO_CAPTURE_GET_FOLDERS_REQUEST,
    payload: { coCode, contextId }
});
export const photoCaptureGetFoldersSuccessAction = photoCaptureGetFolders => ({
    type: PHOTO_CAPTURE_GET_FOLDERS_SUCCESS,
    payload: { photoCaptureGetFolders }
});
//# sourceMappingURL=photoCaptureFoldersAction.js.map